module.exports = "<div class=\"tabs mb24\">\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.transaction.with-discount\" class=\"tabs__item mr8\">\n        <span translate=\"tab_transaction_with_discount\"></span>\n    </a>\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.transaction.export\" class=\"tabs__item mr8\">\n        <span translate=\"tab_transaction_export_history\"></span>\n    </a>\n</div>\n\n<div ui-view></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/discountForStaff/history-tab/discount-for-staff-history-tab.component.html
// module id = 736
// module chunks = 0